const ThumbsUpIcon = ({
  height = 20,
  width = 20,
  color = "#9A9FC6",
}: {
  height?: number
  width?: number
  color?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32541 1.32838C8.46585 1.02744 8.77921 0.833496 9.125 0.833496C10.0533 0.833496 10.9435 1.18469 11.5999 1.80981C12.2563 2.43493 12.625 3.28277 12.625 4.16683V6.66683H16.698C17.0767 6.66349 17.4516 6.73822 17.7972 6.8859C18.1443 7.0343 18.4535 7.2528 18.7032 7.52628C18.9529 7.79975 19.1371 8.12166 19.2432 8.4697C19.3493 8.81774 19.3747 9.18358 19.3176 9.54188L18.1101 17.0418C18.1101 17.042 18.11 17.0422 18.11 17.0424C18.015 17.6383 17.6971 18.1814 17.2149 18.5718C16.7338 18.9612 16.1216 19.1724 15.4905 19.1668H3C2.30381 19.1668 1.63613 18.9034 1.14384 18.4346C0.651562 17.9658 0.375 17.3299 0.375 16.6668V10.8335C0.375 10.1705 0.651562 9.53457 1.14384 9.06573C1.63613 8.59689 2.30381 8.3335 3 8.3335H5.05636L8.32541 1.32838ZM4.75 10.0002H3C2.76794 10.0002 2.54538 10.088 2.38128 10.2442C2.21719 10.4005 2.125 10.6125 2.125 10.8335V16.6668C2.125 16.8878 2.21719 17.0998 2.38128 17.2561C2.54538 17.4124 2.76794 17.5002 3 17.5002H4.75V10.0002ZM6.5 17.5002H15.495L15.5049 17.5002C15.7159 17.5025 15.9207 17.4321 16.0815 17.3019C16.2423 17.1717 16.3483 16.9906 16.3799 16.7919L17.5874 9.29178C17.5874 9.29189 17.5874 9.29167 17.5874 9.29178C17.6064 9.17245 17.5979 9.05028 17.5626 8.93438C17.5273 8.81837 17.4658 8.71107 17.3826 8.61991C17.2994 8.52875 17.1963 8.45591 17.0806 8.40645C16.9649 8.35699 16.8392 8.33207 16.7124 8.33344L16.7025 8.3335H11.75C11.2668 8.3335 10.875 7.9604 10.875 7.50016V4.16683C10.875 3.7248 10.6906 3.30088 10.3624 2.98832C10.1631 2.79845 9.92056 2.65912 9.65685 2.57899L6.5 9.34367V17.5002Z"
        fill={color}
      />
    </svg>
  )
}

export default ThumbsUpIcon
